"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _axios = _interopRequireDefault(require("axios"));
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../middleware/utils");
var _CalculatorTemplate = require("../Wizard/CalculatorTemplate");
var _ProgressBarStepList = _interopRequireDefault(require("../Wizard/ProgressBarStepList"));
var _Wizard = require("../Wizard/Wizard.js");
var _FinancialPlanningCheckupWizardTool = require("./FinancialPlanningCheckupWizardTool.config");
var _FPCTPageFour = _interopRequireDefault(require("./FPCTPageFour"));
var _FPCTPageFourConfirmation = _interopRequireDefault(require("./FPCTPageFourConfirmation"));
var _FPCTPageOne = _interopRequireDefault(require("./FPCTPageOne"));
var _FPCTPageThree = _interopRequireDefault(require("./FPCTPageThree"));
var _FPCTPageTwo = _interopRequireDefault(require("./FPCTPageTwo"));
var _lodash = require("lodash");
var _reactBootstrap = require("react-bootstrap");
var _reactBlueprintLibrary = require("react-blueprint-library");
var _Strategy = _interopRequireDefault(require("./svg/Strategy"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var FinancialPlanningCheckupWizardTool = props => {
  var {
    config
  } = props;
  var [stepNumber, setStepNumber] = (0, _react.useState)(0);
  var [isSubmitted, setIsSubmitted] = (0, _react.useState)(false);
  var [errorData, setErrorData] = (0, _react.useState)(null);
  var currentConfig = config.Steps[stepNumber];
  var submitAction = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (values) {
      // Reset errorData to get rid of any Alerts
      setErrorData(null);
      var newValues = _objectSpread({}, values);
      newValues.goals = values.goalsList.join(', ');
      newValues.productsOwned = values.productsOwnedList.join(', ');
      newValues.productsSuggested = values.productsSuggestedList.join(', ');
      var requestBody = {
        calcType: 'FPCT',
        data: newValues
      };
      return yield _axios.default.post(config.API_URL, requestBody).then(response => {
        if (response.status === 200 || response.status === 201) {
          setIsSubmitted(true);
        }
      }).catch(error => {
        setErrorData(error.msg ? error.msg : error);
        console.error('FinancialPlanningCheckupWizardTool.js submitAction () error: ', error);
      });
    });
    return function submitAction(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  // Disclosure modal handler here
  var [showDisclosureModal, setShowDisclosureModal] = (0, _react.useState)(false);
  var disclosureHandleClose = () => {
    setShowDisclosureModal(false);
  };
  var disclosureHandleShow = () => {
    (0, _utils.customTealiumEvent)(_FinancialPlanningCheckupWizardTool.calcName, 'click', 'disclosure');
    setShowDisclosureModal(true);
  };
  var submitToPdf = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(function* (values) {
      // Reset errorData to get rid of any Alerts
      setErrorData(null);
      var requestBody = {
        calcType: 'FPCT',
        data: values
      };
      var headers = {
        responseType: 'arraybuffer'
      };
      try {
        var apiUrl = (0, _lodash.get)(config, 'CONTENT_API_CALC_PDF', '/apicalls/calculator/html2pdf');
        yield _axios.default.post(apiUrl, requestBody, headers).then(response => {
          var file = new Blob([response.data], {
            type: 'application/pdf'
          });
          var fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        });
      } catch (error) {
        console.error(error);
        setErrorData(error.msg ? error.msg : error);
      }
    });
    return function submitToPdf(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var showContentBelowWizard = () => stepNumber == 3 && !isSubmitted;
  return /*#__PURE__*/_react.default.createElement("div", {
    id: _FinancialPlanningCheckupWizardTool.calcName
  }, /*#__PURE__*/_react.default.createElement(_CalculatorTemplate.CalculatorTemplate, {
    config: config,
    currentConfig: currentConfig,
    stepNumber: stepNumber,
    customSideContent: [null, null, null, null]
  }, /*#__PURE__*/_react.default.createElement(_ProgressBarStepList.default, {
    activeStep: isSubmitted ? 0 : stepNumber + 1,
    steps: config.Steps.length,
    detailedStepper: true,
    stepTitle: ['Goals', 'Assessment', 'Analysis', 'Connect & download']
  }), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Row, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, showContentBelowWizard() && {
    lg: 8
  }, /*#__PURE__*/_react.default.createElement(_Wizard.Wizard, {
    passthroughId: "FinancialPlanningCheckupWizardTool",
    setStepNumber: setStepNumber,
    stepNumber: stepNumber,
    initialValues: _FinancialPlanningCheckupWizardTool.initialValuesConfig,
    initialTouched: _FinancialPlanningCheckupWizardTool.initialTouchedConfig,
    onSubmit: () => {},
    currentConfig: currentConfig
    // validationData={validationData}
    ,
    errorData: errorData,
    calcName: _FinancialPlanningCheckupWizardTool.calcName,
    maxSteps: 4,
    isNotNatLang: [true, true, true, true],
    centerNavButtons: [false, false, false, false]
  }, /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _FinancialPlanningCheckupWizardTool.validationConfig[0]
  }, /*#__PURE__*/_react.default.createElement(_FPCTPageOne.default, null)), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _FinancialPlanningCheckupWizardTool.validationConfig[1]
  }, /*#__PURE__*/_react.default.createElement(_FPCTPageTwo.default, null)), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    onSubmit: null,
    validationSchema: _FinancialPlanningCheckupWizardTool.validationConfig[2],
    sideButtonOnClick: disclosureHandleShow
  }, /*#__PURE__*/_react.default.createElement(_FPCTPageThree.default, {
    disclosureHandleClose: disclosureHandleClose,
    showDisclosure: showDisclosureModal
  })), /*#__PURE__*/_react.default.createElement(_Wizard.WizardStep, {
    hideBack: isSubmitted,
    hideNext: isSubmitted,
    onSubmit: submitAction,
    validationSchema: _FinancialPlanningCheckupWizardTool.validationConfig[3]
  }, isSubmitted ? /*#__PURE__*/_react.default.createElement(_FPCTPageFourConfirmation.default, {
    submitToPdf: submitToPdf
  }) : /*#__PURE__*/_react.default.createElement(_FPCTPageFour.default, null)))), showContentBelowWizard() && /*#__PURE__*/_react.default.createElement(_reactBootstrap.Col, {
    lg: 4
  }, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card, null, /*#__PURE__*/_react.default.createElement(_reactBlueprintLibrary.Card.Body, null, /*#__PURE__*/_react.default.createElement(_Strategy.default, null), /*#__PURE__*/_react.default.createElement("h4", null, "Your personalized strategy for planning and protection"), /*#__PURE__*/_react.default.createElement("p", null, "When you work with a MassMutual financial professional, you get a trusted partner who can offer tailored wealth management guidance for your financial goals at every life stage.")))))));
};
var _default = exports.default = FinancialPlanningCheckupWizardTool;